import React from 'react';
import './DownloadApp.css';

export default function DownloadApp() {
  return (
    <section className="download-app-section section-padding" id="download-app">
      <div className="container download-container">
        <div className="download-grid">
          {/* Left Column: Copy & Store badges */}
          <div className="download-info">
            <h2 className="download-title">
  <span className="download-title-line1">Download <span className="text-gradient">Haatza</span>: Sell Anywhere,</span>
  <span className="download-title-line2">Anytime</span>
</h2>
            <p className="download-text">
              Download Haatza today and unlock the power to sell anywhere, anytime! Our easy-to-use platform is designed for entrepreneurs who want to expand their reach and maximize sales. Join thousands of satisfied users who have transformed their businesses with Haatza. Get started now and take your selling strategy to new heights!
            </p>

            <div className="download-badges">
              {/* Google Play Store */}
              <a
                href="https://play.google.com/store/apps/details?id=com.haatza.seller&hl=en_IN&pli=1"
                target="_blank"
                rel="noopener noreferrer"
                className="store-badge-btn"
                aria-label="Get it on Google Play"
              >
                <img
                  src="https://static.wixstatic.com/media/fe689e_1646a16d01e34776802d4298e41c4d70~mv2.png/v1/fill/w_245,h_70,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/play%20store_edited.png"
                  alt="Get it on Google Play"
                  className="store-badge-img play-store-img"
                />
              </a>

              {/* Apple App Store */}
              <a
                href="https://apps.apple.com/in/app/haatza-seller-sell-online/id6741692569"
                target="_blank"
                rel="noopener noreferrer"
                className="store-badge-btn"
                aria-label="Download on the App Store"
              >
                <img
                  src="https://static.wixstatic.com/media/fe689e_4c04f30e6ba64813a604242e604387b6~mv2.png/v1/fill/w_264,h_78,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/App%20store_edited.png"
                  alt="Download on the App Store"
                  className="store-badge-img app-store-img"
                />
              </a>
            </div>
          </div>

          {/* Right Column: App Screenshot */}
          <div className="download-visual">
            <div className="download-phone-img-wrapper">
              <img
                src="https://static.wixstatic.com/media/fe689e_4d8ce85eaa564dfd8c80b0cd9d820f42~mv2.png/v1/fill/w_261,h_566,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot_1738554353.png"
                alt="Haatza Seller App Screenshot"
                className="download-phone-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
